import React from 'react';
import Modal from 'components/Modal';
import { translate } from 'react-i18next';

class FrozenModal extends React.Component {
  render() {
    let modal = null;

    if (this.props.active) {
      const header = this.props.t('FrozenModal.subscription_cancelled');
      const body = <p>{this.props.t('FrozenModal.account_not_active', { brandName: window.EmployeeWeb.ENVConfig.brand_name })}</p>;
      modal = (
        <div className="modal-wrapper">
          <Modal
            header={header}
            body={body}
          />
        </div>
      );
    }

    return modal;
  }
}

export default translate()(FrozenModal);
